export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const SHOW_SUBMENU = 'SHOW_SUBMENU';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CHANGE_TASKS_INFO = 'CHANGE_TASKS_INFO';
export const CHANGE_INVALID_SESSION = 'CHANGE_INVALID_SESSION';
export const SET_DEPOSIT = 'SET_DEPOSIT';

export const COLLAPSE_FILTERS = 'COLLAPSE_FILTERS';
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';

export const SHOW_CONFETTI = 'SHOW_CONFETTI';
export const HIDE_CONFETTI = 'HIDE_CONFETTI';
export const SET_STREAMER_TIME_PERIOD = 'SET_STREAMER_TIME_PERIOD';
